// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"421ac203","285":"3c8f9807","358":"8eae38ac","584":"cd0f5c36","995":"56c3282d"}[chunkId] + ".chunk.js";
};